/*
 * @Author: Merlin
 * @Date: 2025-04-10 13:35:20
 * @LastEditors: Merlin
 * @LastEditTime: 2025-04-10 13:44:00
 * @Description: 
 */



// ▼用于游戏 keno
export const notificationPage = {
    notification: {
        en: 'Notification',
        cn: '通知',
    },
    PleaseSelect: {
        en: 'Please select',
        cn: '请选择',
    },
    viewAll: {
        en: 'View all',
        cn: '查看全部',
    },
    unread: {
        en: 'Unread',
        cn: '未读',
    },
    typePlatform: {
        en: 'Platform',
        cn: '平台',
    },
    typePersonal: {
        en: 'Personal',
        cn: '个人',
    },
    setAllAsRead: {
        en: 'Mark all as read',
        cn: '标记全部为已读',
    },
    setAllAsReadConfirm: {
        en: 'Are you sure to: Mark all as read?',
        cn: '是否确定：标记全部为已读？',
    },
    loading: {
        en: 'loading...',
        cn: '正在加载……',
    },
    noMoreData: {
        en: 'No more data',
        cn: '没有更多了',
    },
    goTop: {
        en: 'Go top',
        cn: '返回顶部',
    },
    new: {
        en: 'New',
        cn: '新的',
    },
    join: {
        en: 'Join now',
        cn: '立即加入',
    },
    setOneAsRead: {
        en: 'Mark as Read',
        cn: '标为已读',
    },
    noData: {
        en: `You don't have any platform notifications`,
        cn: '您沒有任何平台通知',
    },
    shallAll: {
        en: 'Shall all',
        cn: '显示全部',
    },
    Hide: {
        en: 'Hide',
        cn: '隐藏',
    },
    NetworkError: {
        en: 'Network error, please check your current connection.',
        cn: '网络异常，请检查当前网络',
    },
};




